module.exports = __webpack_public_path__ + "941da5f86644fb4557a682f725f27093.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-pirate.png
// module id = 2775
// module chunks = 0